export default __webpack_public_path__ + "static/media/logo-white.e496b230.svg";